import { object, string, number, array } from 'yup';

export const offerValidationSchema = object().shape({
  name: string().required('Name is required').max(48),
  description: string().max(255),
  minQuota: number()
    .required('Min daily quota is required')
    .min(1, 'Min daily quota must be at least 1'),
  plugin: object()
    .nullable()
    .when('dealType', {
      is: (dealType: string) => dealType === 'buy' || dealType === 'exchange',
      then: (schema) =>
        schema
          .required('At least one plugin should be selected')
          .test(
            'plugin-selected',
            'At least one plugin should be selected',
            (value) => value != null && typeof (value as any).id === 'number' && (value as any).id > 0
          ),
      otherwise: (schema) => schema.nullable().notRequired()
    }),
  dealType: string().required('Deal type is required'),
  customMetadata: string()
    .nullable()
    .test('is-json', 'Must be a valid JSON object', (value) => {
      if (!value) return true;
      try {
        const parsed = JSON.parse(value);
        return typeof parsed === 'object' && !Array.isArray(parsed);
      } catch (e) {
        return false;
      }
    })
});

export const editOfferValidationSchema = object().shape({
  name: string().required('Name is required').max(48),
  description: string().max(255),
  dealType: string().required('Deal type is required'),
  customMetadata: string()
    .nullable()
    .test('is-json', 'Must be a valid JSON object', (value) => {
      if (!value) return true;
      try {
        const parsed = JSON.parse(value);
        return typeof parsed === 'object' && !Array.isArray(parsed);
      } catch (e) {
        return false;
      }
    })
});
